export default __webpack_public_path__ + "static/media/fine_art_6.15903abb.jpg";